import Vue from "vue";
import Vuex from "vuex";
import $axios from "./prototypes/axios";

Vue.use(Vuex);

// code: "1", code_name: "Admin"
// code: "2", code_name: "지자체"
// code: "3", code_name: "관리사"
// code: "4", code_name: "상담사"
// code: "5", code_name: "데이터인력"
// code: "9", code_name: "SK관리자"

export default new Vuex.Store({
  state: {
    user: null,
    groupData: null,
    errorState: null,
    permissions: {},
  },
  getters: {},
  mutations: {
    setUserData(state, payload) {
      // 어드민이면 orgCode 빈값으로 초기화
      if (payload.orgCode === "0000") payload.orgCode = "";

      state.user = payload;
    },
    setGroupData(state, payload) {
      _.forEach(payload.orgList, (org) => {
        const matchedOrg = _.find(payload.stateList, { orgCode: org.orgCode });
        if (matchedOrg) org.states = matchedOrg.states;
      });
      state.groupData = payload.orgList;
    },
    setErrorState(state, payload) {
      state.errorState = payload;
    },
    addPermissionData(state, payload) {
      // 지역ID가 ALL일때 빈값으로 변경
      if (payload.data.region) {
        _.map(["org", "state", "city", "group"], (key) => {
          if (payload.data.region[key].baseId === "ALL")
            payload.data.region[key].baseId = "";
          if (payload.data.region[key].baseName === "ALL")
            payload.data.region[key].baseName = "";
        });
      }
      state.permissions[payload.key] = payload.data;
    },
  },
  actions: {
    loadPermission({ state, commit }, permissionInfo) {
      const key = permissionInfo.key;
      if (state.permissions[key]) return Promise.resolve();
      return new Promise((resolve, reject) => {
        let data = { accessable: false };
        const ajaxList = [];
        ajaxList.push(
          $axios.get(`/admin/auth/access/${key}`).then((res) => {
            data.accessable = res.data === true;
          })
        );
        if (permissionInfo.region)
          ajaxList.push(
            $axios.get(`/admin/auth/permission/${key}/region`).then((res) => {
              data.region = res.data;
            })
          );
        if (permissionInfo.range)
          ajaxList.push(
            $axios.get(`/admin/auth/permission/${key}/range`).then((res) => {
              data.range = res.data;
            })
          );
        Promise.all(ajaxList)
          .then(() => {
            commit("addPermissionData", { key, data });
            resolve();
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
  },
});
